import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

document.addEventListener("DOMContentLoaded", () => {
  const url = window.location.href;
  const pageUrl = encodeURIComponent(url);
  const pageTitle = encodeURIComponent(document.title);
  const pageSource = encodeURIComponent(window.location.hostname);

  const facebookBtn = document.querySelector(".facebook");
  const twitterBtn = document.querySelector(".twitter");
  const linkedinBtn = document.querySelector(".linkedin");
  const mailBtn = document.querySelector(".mail");

  if (facebookBtn) {
    facebookBtn.href = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
  }
  if (twitterBtn) {
    twitterBtn.href = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`;
  }
  if (linkedinBtn) {
    linkedinBtn.href = `https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}&title=${pageTitle}&summary=&source=${pageSource}`;
  }
  if (mailBtn) {
    mailBtn.href = `mailto:?subject=${pageTitle}&body=${pageUrl}`;
  }

  // Delegate copy link clicks so it also works after Sprig/Alpine swaps
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".copylink");
    if (!btn) return;
    e.preventDefault();

    // const original = btn.textContent;  // we no longer change button text
    const message = btn.getAttribute("data-copied-text") || "Copied!";

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          Toastify({
            text: message,
            duration: 3000,
            gravity: "top", // `top` or `bottom`
            position: "right", // `left`, `center` or `right`
            backgroundColor: "#333", // adjust as needed
          }).showToast();
        })
        .catch(() => {
          Toastify({
            text: message,
            duration: 3000,
            gravity: "top",
            position: "right",
            backgroundColor: "#333",
          }).showToast();
        });
    } else {
      // fallback for http/dev contexts:
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch {}
      document.body.removeChild(ta);
      Toastify({
        text: message,
        duration: 3000,
        gravity: "top",
        position: "right",
        backgroundColor: "#333",
      }).showToast();
    }
  });
});
